import React from 'react'
import PropTypes from 'prop-types'
import { imageMap, labelMap } from 'src/pages/main/house/const/houseConstants'

const RankProfileCard = ({ type }) => {
  const imageSrc = imageMap[type] || imageMap.bronze
  const label = labelMap[type] || 'ブロンズ'

  return (
    <div className="flex items-center gap-[2px] rounded-full bg-[#124957] px-1.5 py-0.5 xs:gap-1 xs:py-1">
      <span className="w-4 h-4 xs:w-5 xs:h-5">
        <img className="w-full h-full" src={imageSrc} alt="rank" />
      </span>
      <span className="text-[10px] font-medium text-white">{label}</span>
    </div>
  )
}

RankProfileCard.propTypes = {
  type: PropTypes.oneOf(['bronze', 'silver', 'gold']),
  width: PropTypes.string
}

export default RankProfileCard
